let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9o5Js")).then(() => parcelRequire('bo4yT'));